import { Fragment, useState, useEffect } from "react";

import { Col, Container, Row, FormGroup, InputGroup } from "reactstrap";

import AddressBookListItem from "./AddressBookListItem";

function AddressBookList(props) {
  const [filteredAddresses, setFilteredAddresses] = useState(props.addresses);

  useEffect(() => {
    setFilteredAddresses(props.addresses);
  }, [props.addresses]);

  function onSearchKeywordChange(e) {

    const searchResults = props.addresses.filter(
      (address) =>
        address.EmailAddress.toLowerCase().indexOf(
          e.target.value.toLowerCase()
        ) > -1 ||
        address.FirstName.toLowerCase().indexOf(e.target.value.toLowerCase()) >
          -1 ||
        address.LastName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
    );

    setFilteredAddresses(searchResults);
  }

  function addressViewAllClickHandler() {
    setFilteredAddresses(props.addresses);
  }

  return (
    <Fragment>
      <Container className="g-0">
        <Row className="address-search-form g-0">
          <Col xs="12" className="g-0">
            <FormGroup>
              <InputGroup>
                <input
                  className="form-control"
                  type="text"
                  id="searchKeyword"
                  name="searchKeyword"
                  placeholder="Type to Search..."
                  onChange={onSearchKeywordChange}
                />{" "}
                <button
                  className="btn btn-primary btn-sm"
                  onClick={addressViewAllClickHandler}
                >
                  View All
                </button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
        
        {props.addresses && (
          <Row className="g-0 address-book-list">
            <Col xs="12" className="g-0 scroll-element">
              <table className="table" cellSpacing="0" cellPadding="0">
                <tbody>
                  {filteredAddresses.map((address) => (
                    <AddressBookListItem
                      key={address.Id}
                      address={address}
                      onSelectClickHander={props.onSelectClickHandler}
                      onEditClickHandler={props.onAddressEditClickHandler}
                      onDeleteClickHandler={props.onAddressDeleteClickHandler}
                    />
                  ))}
                </tbody>
              </table>
            </Col>
          </Row>
        )}
        {!props.addresses && (
          <Row className="g-0">
            <Col xs="12" className="g-0">
              <p>
                You have no saved addresses. Please add new addresses using the
                recipient address form.
              </p>
            </Col>
          </Row>
        )}
      </Container>
    </Fragment>
  );
}

export default AddressBookList;
